import ImagePreviewSpace from './ImagePreviewSpace'

export default ImagePreviewSpace
